import { BaseObject } from '@uniqoders/sdk';
export default class Subscription extends BaseObject {
    get price() {
        return this.attributes.price;
    }
    get product() {
        return this.attributes.product;
    }
    get stripeId() {
        return this.attributes.stripe_id;
    }
    get stripePrice() {
        return this.attributes.stripe_price;
    }
    get stripeStatus() {
        return this.attributes.stripe_status;
    }
}
